export default __webpack_public_path__ + "static/media/blue-marker.37a03f25.svg";